import { motion } from "framer-motion";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1709626011485-6fe000ea2dbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMDNkJTIwZ2VvbWV0cmljJTIwZ2xhc3MlMjBkYXJrfGVufDB8fHx8MTc4NjM4Mjc0NHww&ixlib=rb-4.1.0&q=85",
  network: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxkYXJrJTIwbW9vZHklMjBkYXRhJTIwY2VudGVyJTIwbmV0d29yayUyMGNhYmxlc3xlbnwwfHx8fDE3ODYzODI4NDl8MA&ixlib=rb-4.1.0&q=85",
  code: "https://images.unsplash.com/photo-1599837565318-67429bde7162?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxzb2Z0d2FyZSUyMGRldmVsb3BlciUyMGNvZGUlMjBzY3JlZW4lMjBkYXJrfGVufDB8fHx8MTc4NjM4Mjg1MHww&ixlib=rb-4.1.0&q=85",
  arch: "https://images.unsplash.com/photo-1485025798926-cde0f0d24cca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBhYnN0cmFjdCUyMGRhcmslMjBidWlsZGluZ3xlbnwwfHx8fDE3ODYzODI4NTB8MA&ixlib=rb-4.1.0&q=85",
  team: "https://images.unsplash.com/photo-1531973576160-7125cd663d86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjB0ZWFtJTIwbW9kZXJuJTIwb2ZmaWNlJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NjM4Mjc0NHww&ixlib=rb-4.1.0&q=85",
  servers: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxkYXJrJTIwbW9vZHklMjBkYXRhJTIwY2VudGVyJTIwbmV0d29yayUyMGNhYmxlc3xlbnwwfHx8fDE3ODYzODI4NDl8MA&ixlib=rb-4.1.0&q=85",
  voip: "https://images.unsplash.com/photo-1587560699334-bea93391dcef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxvZmZpY2UlMjBWb0lQJTIwZGVzayUyMHBob25lJTIwYnVzaW5lc3N8ZW58MHx8fHwxNzg2Mzg3NjM4fDA&ixlib=rb-4.1.0&q=85",
  support: "https://images.unsplash.com/photo-1712159018726-4564d92f3ec2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxJVCUyMHRlY2huaWNpYW4lMjBuZXR3b3JrJTIwc3VwcG9ydCUyMGhlYWRzZXQlMjBjYWxsJTIwY2VudGVyfGVufDB8fHx8MTc4NjM4NzYzOHww&ixlib=rb-4.1.0&q=85",
};

export const easeOut = [0.16, 1, 0.3, 1];

// Line-mask reveal: wrap each line in overflow-hidden, translate inner up
export function MaskLine({ children, delay = 0, className = "" }) {
  return (
    <span className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block"
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1, ease: easeOut, delay }}
      >
        {children}
      </motion.span>
    </span>
  );
}

// Scroll-triggered reveal wrapper
export function Reveal({ children, delay = 0, y = 40, className = "", as = "div" }) {
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: easeOut, delay }}
    >
      {children}
    </Comp>
  );
}
